import { render, staticRenderFns } from "./abroad-other.vue?vue&type=template&id=5c1135b3&scoped=true&"
import script from "./abroad-other.vue?vue&type=script&lang=js&"
export * from "./abroad-other.vue?vue&type=script&lang=js&"
import style0 from "./abroad-other.vue?vue&type=style&index=0&id=5c1135b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1135b3",
  null
  
)

export default component.exports